import { Formik, FormikHelpers } from 'formik';
import { LevelUpForm } from '~/components/LevelUp/Form/LevelUpForm';
import { LevelUpValues } from '~/components/LevelUp/LevelUp';
import { useValidate } from '~/components/LevelUp/LevelUp.hooks';

export type LevelUpFormikProps = {
  initialValues: LevelUpValues;
  className?: string;
  onSubmit: (value: LevelUpValues, actions: FormikHelpers<LevelUpValues>) => void;
  enableReinitialize?: boolean;
};

export const LevelUpFormik = ({
  initialValues,
  onSubmit,
  enableReinitialize = false,
}: LevelUpFormikProps) => {
  const { level } = initialValues;
  const validate = useValidate(level);

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      validateOnMount={true}
      enableReinitialize={enableReinitialize}
      onSubmit={onSubmit}>
      <LevelUpForm />
    </Formik>
  );
};
